var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"switch-bg bg-gray-300 rounded-full flex items-center",class:{
    'bg-red': !_vm.value,
    'bg-green': _vm.value == 1,
    'bg-gray-400': _vm.value === 2,
    'opacity-50': _vm.disabled,
    'cursor-pointer': !_vm.disabled
  },on:{"click":function($event){$event.stopPropagation();return _vm.emitInput.apply(null, arguments)}}},[_c('div',{staticClass:"rounded-full bg-white shadow switch-button",class:{ 'active-button': _vm.value == 1, 'half-button': _vm.value == 2 }})])}
var staticRenderFns = []

export { render, staticRenderFns }